import { Box, TableCell, TableRow } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { handleClickAsLink } from '../../../common/utility/handleClickAsLink'

import { getOrgTypes } from '@percent/domain/verifications'
import { Organisation } from '@percent/admin-dashboard/api/types'
import { ReactComponent as DropdownSVG } from '@percent/admin-dashboard/common/assets/images/dropdown.svg'
import { CountryCodeFlag } from '@percent/admin-dashboard/common/components/countryCodeFlag/CountryCodeFlag'
import { Badge } from '@percent/lemonade'
import styles from './OrganizationsTable.module.scss'

type OrganizationsTableRowProps = {
  row: Organisation
}

export function OrganizationsTableRow({ row }: OrganizationsTableRowProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const orgTypes = getOrgTypes({ organisationTypes: row.types ?? null })
  const validTypes = orgTypes.filter(type => type !== 'pending' && type !== 'na')

  return (
    <TableRow key={row.id} onClick={handleClickAsLink(`/organizations/${row.id}`, navigate)}>
      <TableCell>
        <CountryCodeFlag countryCode={row.countryCode} />
      </TableCell>
      <TableCell>{row.name}</TableCell>
      <TableCell>{row.registryId}</TableCell>
      <TableCell>
        {row.claimedAt ? (
          <Badge variant="positive" icon="check">
            {t('typography.claimed')}
          </Badge>
        ) : (
          <Badge variant="default" icon="reject">
            {t('typography.unclaimed')}
          </Badge>
        )}
      </TableCell>
      <TableCell>
        <Box display="flex" flexDirection="column" style={{ gap: '4px', alignItems: 'flex-start' }}>
          {validTypes.length === 0 ? (
            <Badge variant="default">{t('status.notAvailable')}</Badge>
          ) : (
            validTypes.map(orgType => (
              <Badge key={orgType} variant="default">
                {t(`organisationTypes.${orgType}` as any)}
              </Badge>
            ))
          )}
        </Box>
      </TableCell>
      <TableCell>
        <Badge variant={row.registrationActive ? 'positive' : 'critical'}>
          {t(row.registrationActive ? 'status.active' : 'status.inactive')}
        </Badge>
      </TableCell>
      <TableCell
        align="right"
        className={styles.rowIconForward}
        style={{ padding: '0' }}
        data-testid="organization-details-link"
      >
        <DropdownSVG className={styles.arrow} />
      </TableCell>
    </TableRow>
  )
}
